import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import cartReducer, {
  addOrUpdateItem,
  setItemQuantity,
  updateItemNote,
  removeFromCart,
  clearCart,
} from './cartSlice';
import { saveCartItems } from './cartStorage';
import favouritesReducer, { toggleFavourite } from './favouritesSlice';
import { saveFavouriteIds } from './favouritesStorage';

const favouritesListener = createListenerMiddleware();

favouritesListener.startListening({
  actionCreator: toggleFavourite,
  effect: async (_action, api) => {
    const ids = api.getState().favourites.ids;
    await saveFavouriteIds(ids);
  },
});

const cartListener = createListenerMiddleware();

const cartActions = [addOrUpdateItem, setItemQuantity, updateItemNote, removeFromCart, clearCart];
cartActions.forEach((action) => {
  cartListener.startListening({
    actionCreator: action,
    effect: (_action, api) => {
      saveCartItems(api.getState().cart.items);
    },
  });
});

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    favourites: favouritesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .prepend(favouritesListener.middleware)
      .prepend(cartListener.middleware),
});
